import { NgClass } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({

  selector: 'siat-split-button',
  imports: [
    MatMenuModule,
    MatIconModule,
    MatButtonToggleModule,
    MatTooltipModule,
    FormsModule,
    NgClass,
  ],
  templateUrl: './split-button.component.html',
  styleUrls: ['./split-button.component.scss'],
})
export class SplitButtonComponent {
  /**
   * Class to apply to the container element.
   * @example calendar-split-button
   */
  containerClass = input<string>();

  /**
   * Label to display on the button.
   */
  label = input<string>();

  /**
   * Icon to display on the button
   */
  icon = input<string>();

  /**
   * Options to display in the dropdown
   */
  options = input<string[]>();

  /**
   * Tooltip shown on the main button, describing what the dropdown contains.
   */
  tooltip = input<string>();

  onChangeEvent = output<string>();

  onToggleOptions(items: string): void {
    this.onChangeEvent.emit(items);
  }
}
